/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router-dom';
import { dateDiff, roleCondition, timeFormat } from '../../../libs/HelperContent';
import { useDispatch, useSelector } from 'react-redux';
import { LanguageContext } from '../../../libs/Context';
import TrainingNotification from './TrainingNotification';
import { updateBpsNotification } from '../../../redux/UserSessionSlice';
import { toast } from 'react-toastify';
import ProfilePic from '../../../components/Common/ProfilePic';

const NotificationView = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { data } = props;
	const session = useSelector((state:any) => state?.mysession?.session);
	const userConfigs = useSelector((state:any) => state?.mysession?.userConfigs);
	const menuData = useSelector((state:any) => state?.mysession?.sideMenuData);
	const navigation = useNavigate();
	const dispatch = useDispatch();
	const handleClose = () => {	props?.setNotifyView({ state: false, data: null });	props?.setNotificationSlider(false); };

	// check-menu data enable or not
	const isPWarrentyEnable = menuData.some((item) => item.index === 13 && item.isEnabled);
	const isContractMenuEnable = ((userConfigs?.contractAccess?.isContractEmp &&
    (userConfigs?.contractAccess?.viewContract || userConfigs?.contractAccess?.authorization)) ||
    Object.keys(userConfigs?.contractAccess || {}).length === 0);
	const isMeetingEnable = menuData.some((item) => item.index === 8 && item.isEnabled);
	const isWebinarEnable = menuData.some((item) => item.index === 9 && item.isEnabled);

	// check index value true or false
	const findIndex13 = (array) => array.find((item) => item?.index === 14); // contract
	const findIndex08 = (array) => array.find((item) => item?.index === 8); // meeting
	const findIndex09 = (array) => array.find((item) => item?.index === 9); // webinar

	const handleEmployeeUpdate = (item) =>
	{
		if (session?.userId === item?.creatorProfile?.userId)
		{
			navigation(`/businessSettings/employees/profile/${item?.receiverId[0]}`);
		}
		else
		{
			navigation('/me');
		}
	};

	const handleEmployeeSignup = (item) =>
	{
		if (roleCondition(session?.empRole) &&
        session?.companyId === item?.creatorProfile?.companyId)
		{
			navigation('/businessSettings/employees?tab=1');
		}
	};

	const handleCertification = () =>
	{
		if ((data?.creatorProfile?.userId === session?.userId) ||
        (data?.createdBy === session?.userId))
		{
			navigation('/certification?tab=1');
		}
		else
		{
			navigation('/certification/?tab=0');
		}
	};

	const handleRecognition = (item) =>
	{
		if (item?.creatorProfile?.userId === session?.userId)
		{
			navigation('/businessSettings/recognition');
		}
		else
		{
			navigation('/me?e=a&recog=true');
		}
	};

	// warranty...notification
	const handleWarranty = (item) =>
	{
		if (isPWarrentyEnable)
		{
			navigation(`/productWarranty/view/${window.btoa(item?.data?.companyId)}/${window.btoa(item?.data?.id)}`);
		}
		else
		{
			toast.error(language?.notifyPWNotEnbale, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	const handleProspectus = (item) =>
	{
		dispatch(updateBpsNotification(item?.id));
		navigation('/businessprospects');
	};

	// contract... notification
	const handleContract = (item) =>
	{
		if (isContractMenuEnable && findIndex13(menuData))
		{
			navigation(`/contractManagement/view/${window.btoa(item?.data?.id)}`);
		}
		else
		{
			toast.error(language?.notifyCMNotEnable, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	const handleTemplateContract = (item) =>
	{
		const templateObj = {
			templateApproveReject : 'approved',
			TemplateRequest       : 'pending'
		};

		// / removed findIndex13(menuData) as we are not checking contracts from self

		if (isContractMenuEnable)
		{
			navigation(`/businessSettings/contractManagement/view/${window.btoa(item?.data?.id)}/${templateObj[item?.type]}`);
		}
		else
		{
			toast.error(language?.notifyCMNotEnable, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	// meeting... notification
	const handleMeetings = (item) =>
	{
		if (isMeetingEnable && findIndex08(menuData))
		{
			navigation(`/meetings?id=${window.btoa(item?.id)}`);
		}
		else
		{
			toast.error(language?.notifyCMNotEnable, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	// webinar... notification
	const handleWebinars = (item) =>
	{
		if (isWebinarEnable && findIndex09(menuData))
		{
			navigation(`/webinars/view/${window.btoa(item?.id)}`);
		}
		else
		{
			toast.error(language?.notifyCMNotEnable, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};
	// if other than below handlers are comes from api response, then Click here will not work

	const handleFeedNavigation = (item) =>
	{
		navigation(`/news?post=${window.btoa(item?.id)}`);
	};

	const navigationHandlers = {
		feed                                : handleFeedNavigation,
		'feed report abuse'                 : handleFeedNavigation,
		feed_created                        : handleFeedNavigation,
		feed_approved                       : handleFeedNavigation,
		connection                          : () => navigation(`/connections/companyprofile/${window.btoa(data?.id)}?tab=0`),
		'update connection'                 : () => navigation(`/connections/companyprofile/${window.btoa(data?.id)}?tab=0`),
		'cancel connection'                 : () => navigation(`/connections/companyprofile/${window.btoa(data?.id)}?tab=0`),
		'reject connection'                 : () => navigation(`/connections/companyprofile/${window.btoa(data?.id)}`),
		'relationship manager'              : () => navigation(`/connections/companyprofile/${window.btoa(data?.id)}?tab=1&status=true`),
		'given admin privilege'             : handleEmployeeUpdate,
		'employee update'                   : handleEmployeeUpdate,
		'employee signup'                   : handleEmployeeSignup,
		'remove admin privileges'           : handleEmployeeUpdate,
		certification                       : handleCertification,
		follow                              : () => navigation('/connections?tab=4'),
		unfollow                            : () => navigation('/connections?tab=4'),
		unlike                              : (item) => navigation(`/news?post=${window.btoa(item?.id)}`),
		'approve connection'                : () => navigation(`/connections/companyprofile/${window.btoa(data?.id)}`),
		'reply to comment'                  : (item) => navigation(`/news?type=comment&post=${window.btoa(item?.id)}`),
		createtask                          : (item) => navigation(`/tasks/${item?.id}?tab=0`),
		'scheduled reminder'                : (item) => navigation(`/tasks/${item?.id}?tab=1`),
		comment                             : (item) => navigation(`/news?post=${window.btoa(item?.id)}&type=comment`),
		like                                : (item) => navigation(`/news?post=${window.btoa(item?.id)}`),
		reminder                            : (item) => navigation(`/tasks/${item?.reminderId ? item?.reminderId : item?.id}?tab=1&filter=previous&`),
		'super admin signup'                : () => navigation('/me'),
		'give super-admin privilege'        : () => navigation('/me'),
		name                                : () => navigation('/me'),
		'deal rejection'                    : (item) => navigation(`/dealviewDetails/${item?.data?.dealId}`),
		'deal opportunity'                  : (item) => navigation(`/dealviewDetails/${item?.data?.dealId}`),
		dealconfirm                         : (item) => navigation(`/dealviewDetails/${item?.data?.dealId}`),
		'deal registration'                 : (item) => navigation(`/dealviewDetails/${item?.data?.dealId}`),
		'deal extended'                     : (item) => navigation(`/dealviewDetails/${item?.data?.dealId}`),
		'approve employee'                  : () => navigation('/businessSettings/employees?tab=0'),
		'reject employee'                   : () => navigation('/businessSettings/employees?tab=2'),
		shareditem                          : () => navigation('/drive?tab=1'),
		deactivateemployee                  : () => navigation('/businessSettings/employees?tab=2'),
		recognition                         : handleRecognition,
		'recognition two'                   : (item) => navigation(`/businessSettings/employees/profile/${item?.id}/?p=arm&recog=true`),
		training_request                    : (item) => navigation(`/training/trainingDetails/${window.btoa(item?.data?.meetingId)}/1`),
		'inlynk - licence request approved' : () => navigation('/profile'),
		'warranty request'                  : handleWarranty,
		'warranty approved'                 : handleWarranty,
		'warranty edit'                     : handleWarranty,
		'warranty rejected'                 : handleWarranty,
		'warranty expired'                  : handleWarranty,
		'warranty reminder'                 : handleWarranty,
		'warranty update'                   : handleWarranty,
		prospectus_reassign                 : handleProspectus,
		prospects_reminder                  : handleProspectus,
		prospectus_assign                   : (item) => navigation(`/businessprospects/listview/${window.btoa(item?.receiverId)}/2`),
		'bps notification'                  : () => navigation('/businessprospects'),
		'menu request rejected'             : () => navigation('/businessSettings/menu?tab=1'),
		'menu request approved'             : () => navigation('/businessSettings/menu?tab=1'),
		'social media integration'          : () => navigation('/profileSettings/socialMediaIntegration'),
		contractinitiated                   : handleContract,
		contractsigned                      : handleContract,
		contractapproved                    : handleContract,
		negotiation                         : handleContract,
		contractdeclined                    : handleContract,
		contractterminationraised           : handleContract,
		contractterminationrejected         : handleContract,
		contractterminationaccepted         : handleContract,
		signexpiryreminder                  : handleContract,
		validityexpiryreminder              : handleContract,
		contractvalidityexpired             : handleContract,
		contractreinitiated                 : handleContract,
		renewapproved                       : handleContract,
		templaterequest                     : handleTemplateContract,
		templateapprovereject               : handleTemplateContract,
		'contract-comment'                  : handleContract,
		connectionactive                    : handleContract,
		renewrequestraised                  : handleContract,
		authrizationexpired                 : handleContract,
		certificate_expire                  : (item) => navigation(`/certification/certificationView/${window.btoa(item?.id)}`),
		ticketraised                        : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		'new ticket created'                : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		'ticket closed'                     : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		'ticket status change'              : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		'ticket reopened'                   : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		'new ticket raised'                 : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		reopenticket                        : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		commentticket                       : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=2`),
		'ticket comment'                    : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=2`),
		updateticket                        : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		closedticket                        : (item) => navigation(`/helpandsupport?id=${window.btoa(item?.id)}&viewTicket=1`),
		createMeeting                       : (item) => navigation(`/meeting?id=${window.btoa(item?.data?.id)}`),
		updateMeeting                       : (item) => navigation(`/meeting?id=${window.btoa(item?.data?.id)}`),
		reminderMeeting                     : (item) => navigation(`/meeting?id=${window.btoa(item?.data?.id)}`),
		'schedule-reminder'                 : handleMeetings,
		'schedule-invitation'               : handleMeetings,
		'schedule-cancelled'                : handleMeetings,
		'schedule-updated'                  : handleMeetings,
		'webinar-reminder'                  : handleWebinars,
		'webinar-invitation'                : handleWebinars,
		'webinar-cancelled'                 : handleMeetings,
		'webinar-updated'                   : handleMeetings
	};

	const navigations = (item) =>
	{
		const handler = navigationHandlers[item?.type?.toLowerCase()];

		if (handler)
		{
			handler(item);
			handleClose();
		}
		else
		{
			console.warn(`No handler found for type: ${item?.type}`);
		}
	};

	return (
		<div className='flexMinHeightCol scrollY whiteBg brdrRSM'>
			<div className='flexRow justifyEnd pdngHXS'>
				<button
					tabIndex={0}
					className='flexAutoRow pdngTSM pointer'
					onKeyUp={(e) => { e.key === 'Enter' && props?.setNotifyView({ state: false, data: null }); }}
					onClick={() => props?.setNotifyView({ state: false, data: null })}
				>
					<Tooltip title={language?.back}>
						<KeyboardArrowRightIcon color='primary'/>
					</Tooltip>
				</button>
			</div>
			<div className='flexCol pdngXS'>
				<div className='flexRow pdngHXS pointer'>
					<div className='flexAutoRow pdngXS'>
						<div className='imgAvatarMD brdrRadius50 brdrBlackSM'>
							<ProfilePic
								imagePath={`${data?.role === 'company'
									? `${data?.creatorProfile?.companyId}_profile.jpeg`
									: `${data?.creatorProfile?.userId}.jpeg`}?t=${new Date().valueOf()}`}
								defaultImg='/images/icons/defaultUser.svg'
								alt='profile'
								className='brdrRadius50'
								from={data?.role === 'company' ? '' : 'selfProfile'}
							/>
						</div>
					</div>
					<div className='flexMinWidthCol pdngXS'>
						<span className='capitalTxt'>{data?.creatorProfile?.name ? data?.creatorProfile?.[data?.role === 'company' ? 'companyName' : 'name'] : data?.creatorProfile?.companyName}</span>
						<span className='lightTxt headingSM ellipsisTxt'>{dateDiff(data?.createdAt, new Date().valueOf())}, {timeFormat(data?.createdAt)}</span>
					</div>
				</div>

				{[ 'training_invitation', 'training_cancelled', 'training_slot_confirmation', 'training_updated', 'training_alert', 'invitation' ].includes(data?.type)
					? <TrainingNotification data={data} session={session}/>
					: (
						<>
							<div className='flexCol pdngLMD '>
								<span className='wordBreakWord'>{data?.receiverMessage} {data.type === 'contractTerminationRaised' && `Reason: ${data?.data?.comment}`}</span>
							</div>
							{(!(session?.companyId !== data?.creatorProfile?.companyId && data.type === 'Employee SignUp') &&
                                !(data.type === 'Block' || data.type === 'unblock') &&
                                (data.type !== 'delete Task') &&
                                (data.type !== 'unfollow') &&
                                (data.type !== 'remove manager') &&
                                (data?.type?.toLowerCase() !== 'prospectus_removed')) &&
                                (<div className='flexRow pdngLMD mrgnTSM'><span>{language?.please}<button className='primaryTxt pointer' onKeyUp={(e) => { e.key === 'Enter' && navigations(data); }} onClick={() => navigations(data)}>&nbsp;{language?.clickHere}&nbsp;</button>{language?.toViewFullDetails}</span></div>)}
						</>
					)}
			</div>
		</div>
	);
};

export default NotificationView;